import { render, staticRenderFns } from "./popup-box.vue?vue&type=template&id=bdc90a5e&scoped=true"
import script from "./popup-box.vue?vue&type=script&lang=js"
export * from "./popup-box.vue?vue&type=script&lang=js"
import style0 from "./popup-box.vue?vue&type=style&index=0&id=bdc90a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc90a5e",
  null
  
)

export default component.exports